import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import NavItemView from '@/views/nav/item';

    var DEFAULT_NAV_TMPL = '';

    function on_select(selected_child_view) {
        this.children.each(function(child_view) {
            if (child_view === selected_child_view) return;
            if (_.isFunction(child_view.deselect)) child_view.deselect();
        });
    }

    export default Marionette.CompositeView.extend({
        tagName: 'ol',
        template: Handlebars.compile(DEFAULT_NAV_TMPL),
        childView: NavItemView,
        childViewEvents: {
            'select': on_select
        }
    });

